import HomepageInformation from './HomepageInformation';

export default HomepageInformation;
